<template>
  <div class="container">
    <div class="login login--header-padding">
      <img src="@/assets/superliga/logo-3x.png" alt="" class="login__logo" v-if="$config.MODE == 'SUPERLIGA'">
      <img src="@/assets/logo.svg" alt="" class="login__logo" v-else>
      <h3>{{$t('login.form.legendIOS')}}</h3>
      <div class="form-group">
        <input 
        type="email"
        v-model.trim="$v.loginModel.email.$model"
        :class="{'has-error': $v.loginModel.email.$error && $v.loginModel.email.$invalid, 'with-value': $v.loginModel.email.$model != ''}"
        :id="$t('login.form.email')" class="form-control" required>
        <label class="form-control-placeholder" :for="$t('login.form.email')">{{$t('login.form.email')}}</label>
      </div>
      <button class="button button--white" @click.prevent="login()" :disabled="$v.loginModel.$invalid || submitted">
        <template v-if="!submitted">
          {{$t('login.login')}}
        </template>
        <template v-else>
          {{$t('login.loading')}} <div class="loading-points"><span>.</span><span>.</span><span>.</span></div>
        </template>
      </button>
      <img src="@/assets/logo.svg" alt="" class="login__logo-footer" v-if="$config.MODE == 'SUPERLIGA'">
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      loginModel: {
        email: ''
      },
      submitted: false
    }
  },
  methods: {
    async login() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.submitted = true
        const request = await this.$store.dispatch("beginChangeAppleMail", this.loginModel)
        if (request == undefined) this.submitted = false
        if (request.status == 200) {
          this.$router.push('/login/ios/activate')
        }
      }
    }
  },
  validations: {
    loginModel: {
      email: {
        required
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/styles/_variables';
  
  .login {
    
    h3 {
      color: $white;
      max-width: 300px;
      text-align: center;
    }

    &__recover {
      color: $white!important;
      @include font-settings(xmilli, base);
      text-transform: uppercase;
      font-family: $font-barlow;
      font-weight: 600;
      padding-left: $margin-base;
      padding-top: $margin-milli / 2;
    }
  }
</style>